import React from "react";
import ReactApexChart from "react-apexcharts";
import { generateDatasetWithColors, formatDate } from "../../utility";
import { ImageViewer } from "../../utility/ImageViewer";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";

export const SummaryCard = ({ data }) => {
  const generatePieOptions = (options) => ({
    chart: {
      type: "pie",
    },
    title: {
      text: "",
      align: "center",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
      },
    },
    legend: {
      position: "right", // Posisikan label di kanan chart
      horizontalAlign: "center", // Pusatkan secara horizontal
      width: 150, // Atur lebar area legend untuk mendekatkan ke chart
      offsetX: -10, // Kurangi jarak horizontal
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
    },
    labels: options,
  });

  const generateBarOptions = (options) => ({
    chart: {
      type: "bar",
    },
    title: {
      text: "",
      align: "center",
      style: {
        fontSize: "18px",
        fontWeight: "bold",
      },
    },
    plotOptions: {
      bar: {
        horizontal: true, // Membuat bar chart menjadi horizontal
        barHeight: "50%", // Atur tinggi bar (persentase atau pixel, misal "30px")
      },
    },
    xaxis: {
      categories: [], // Kategori untuk sumbu X
    },
    legend: {
      show: false,
    },
    labels: options,
  });

  return (
    <>
      <div>
        {data && data.length > 0 ? (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "40px" }}
          >
            {data.map((item, index) => {
              const {
                question_desc = "No Description",
                question_type,
                question_answer = [],
                question_option = [],
                question_answer_total = 0,
                customer_store_name = [],
              } = item || {};

              if (["DROPDOWN", "RADIO_BUTTON"].includes(question_type)) {
                const chartData = {
                  series: question_answer.map((value) => parseInt(value, 10)),
                  options: generatePieOptions(question_option),
                };

                const popover = (
                  <Popover id="popover-basic" title="Customer List">
                    <div
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        padding: "10px",
                        fontFamily: "Arial, sans-serif", // Added for better font readability
                      }}
                    >
                      {question_option.map((option, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                          <h5
                            style={{
                              marginBottom: "8px",
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "#333", // Better color contrast for readability
                            }}
                          >
                            {option}:{" "}
                            <span style={{ fontWeight: "normal" }}>
                              {question_answer[index]}
                            </span>{" "}
                            jawaban
                          </h5>

                          <ul
                            style={{
                              listStyleType: "circle",
                              paddingLeft: "30px",
                              marginTop: "5px", // Added space between the title and list
                              color: "#555", // Lighter text color for list items
                              fontSize: "14px", // Slightly smaller font for list items
                            }}
                          >
                            {customer_store_name[index].map(
                              (store, storeIndex) => (
                                <li
                                  key={storeIndex}
                                  style={{
                                    marginBottom: "8px",
                                    lineHeight: "1.5",
                                  }} // Increased line height for better spacing
                                >
                                  {store}
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </Popover>
                );

                return (
                  <div
                    key={index}
                    style={{
                      padding: "20px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <h5>{question_desc}</h5>
                    <OverlayTrigger
                      trigger="click"
                      placement="right"
                      overlay={popover}
                    >
                      <Button variant="success">
                        {question_answer_total} jawaban
                      </Button>
                    </OverlayTrigger>

                    <div style={{ height: "30vh" }}>
                      <ReactApexChart
                        options={chartData.options}
                        series={chartData.series}
                        type="pie"
                        height="100%"
                      />
                    </div>
                  </div>
                );
              }

              if (["CHECKBOX"].includes(question_type)) {
                const chartData = {
                  series: [
                    {
                      name: "Jumlah",
                      data: question_answer.map(Number),
                    },
                  ],
                  options: generateBarOptions(question_desc),
                };
                chartData.options.xaxis.categories = question_option;

                const popover = (
                  <Popover id="popover-basic" title="Customer List">
                    <div
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        padding: "10px",
                        fontFamily: "Arial, sans-serif", // Added for better font readability
                      }}
                    >
                      {question_option.map((option, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                          <h5
                            style={{
                              marginBottom: "8px",
                              fontWeight: "bold",
                              fontSize: "16px",
                              color: "#333", // Better color contrast for readability
                            }}
                          >
                            {option}:{" "}
                            <span style={{ fontWeight: "normal" }}>
                              {question_answer[index]}
                            </span>{" "}
                            jawaban
                          </h5>

                          <ul
                            style={{
                              listStyleType: "circle",
                              paddingLeft: "30px",
                              marginTop: "5px", // Added space between the title and list
                              color: "#555", // Lighter text color for list items
                              fontSize: "14px", // Slightly smaller font for list items
                            }}
                          >
                            {Array.isArray(customer_store_name[index]) &&
                              customer_store_name[index].map(
                                (store, storeIndex) => (
                                  <li
                                    key={storeIndex}
                                    style={{
                                      marginBottom: "8px",
                                      lineHeight: "1.5",
                                    }} // Increased line height for better spacing
                                  >
                                    {store}
                                  </li>
                                )
                              )}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </Popover>
                );

                return (
                  <div
                    key={index}
                    style={{
                      padding: "20px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <h5>{question_desc}</h5>
                    <OverlayTrigger
                      trigger="click"
                      placement="right"
                      overlay={popover}
                    >
                      <Button variant="success">
                        {question_answer_total} jawaban
                      </Button>
                    </OverlayTrigger>

                    <div style={{ height: "30vh" }}>
                      <ReactApexChart
                        options={chartData.options}
                        series={chartData.series}
                        type="bar"
                        height="100%"
                      />
                    </div>
                  </div>
                );
              }

              if (["TEXT", "NUMBER"].includes(question_type)) {
                return (
                  <div
                    key={index}
                    style={{
                      padding: "20px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <h5>{question_desc}</h5>
                    <p>{question_answer.length} jawaban</p>
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: "0",
                        maxHeight: "200px",
                        overflowY: "auto",
                        margin: "0",
                      }}
                    >
                      {question_answer.map((answer, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {answer.text}
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              }

              if (["DATE"].includes(question_type)) {
                return (
                  <div
                    key={index}
                    style={{
                      padding: "20px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <h5>{question_desc}</h5>
                    <p>{question_answer.length} jawaban</p>
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: "0",
                        maxHeight: "200px",
                        overflowY: "auto",
                        margin: "0",
                      }}
                    >
                      {question_option.map((option, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          {formatDate(option)} - {question_answer[idx]} jawaban
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              }

              if (["PHOTO"].includes(question_type)) {
                return (
                  <div
                    key={index}
                    style={{
                      padding: "20px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <h5>{question_desc}</h5>
                    <p>{question_answer.length} jawaban</p>
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: "0",
                        maxHeight: "200px",
                        overflowY: "auto",
                        margin: "0",
                      }}
                    >
                      {question_answer.map((answer, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                          }}
                        >
                          <a target="_blank" rel="noopener noreferrer">
                            {answer.text}
                          </a>
                          <div className="small-image" key={answer.idx}>
                            <ImageViewer url={answer.url} />
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              }

              return null;
            })}
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "#888" }}>
            Tidak ada data yang tersedia.
          </p>
        )}
      </div>
    </>
  );
};
